/**
 * Totals over DOOH venue delivery.
 *
 * Separate from the fixture so the arithmetic is testable on its own, and so it
 * mirrors what `doohTotals()` in @pdmg/reporting-core does over raw beacon rows: sum
 * the multiplier for impressions, count rows for plays, never read
 * `impressions_count`.
 *
 * The sum is kept UNROUNDED. Real multipliers are fractional (1.34, 3.1, 8.5), and
 * rounding per venue before summing accumulates error across thousands of rows — on a
 * 5,000-venue campaign that is a visible discrepancy between the report's headline
 * figure and its own table.
 */

export interface VenueRow {
  plays: number;
  impressions: number;
  unmatchedScreen?: boolean;
}

export interface VenueTotals {
  plays: number;
  impressions: number;
  unmatched: number;
}

export function doohVenueTotals(rows: VenueRow[]): VenueTotals {
  let plays = 0;
  let impressions = 0;
  let unmatched = 0;
  for (const r of rows) {
    plays += r.plays;
    impressions += r.impressions;
    if (r.unmatchedScreen) unmatched++;
  }
  // Round only at the end, and only to cents-level precision, so the total matches
  // what a reader gets by adding the column themselves.
  return { plays, impressions: Number(impressions.toFixed(2)), unmatched };
}
